export enum RecommendationType {
  ORGANIZATIONAL_GOALS = 1,
  TEAM_RECOMMENDATIONS = 2,
  FOUNDATIONS = 3,
  INTERVENTIONS = 4,
}
